import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default class extends Controller {
  static targets = ["pinWrap", "line", "punchline"]

  connect() {
    document.fonts.ready.then(() => {
      requestAnimationFrame(() => this.setup())
    })
  }

  disconnect() {
    ScrollTrigger.getAll().forEach((t) => t.kill())
  }

  setup() {
    const pinWrap = this.pinWrapTarget
    const lines = this.lineTargets
    const punchline = this.punchlineTarget
    if (!pinWrap || !lines.length || !punchline) return

    const perLine = 400
    const punchScroll = 300
    const totalScroll = (lines.length * perLine) +
      punchScroll

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: pinWrap,
        start: "top top",
        end: `+=${totalScroll}`,
        pin: true,
        scrub: true,
        pinSpacing: true
      }
    })

    // Each line: hold white, then cross out and
    // fade to gray
    lines.forEach((line) => {
      // Hold
      tl.to({}, { duration: 0.08 })

      // Cross out + fade to gray
      tl.to(line, {
        color: "#374151",
        textDecorationLine: "line-through",
        textDecorationColor: "#6b7280",
        duration: 0.15,
        ease: "power2.inOut"
      })
    })

    // Hold after all crossed out
    tl.to({}, { duration: 0.1 })

    // Punchline fades in
    tl.to(punchline, {
      autoAlpha: 1,
      color: "#fff",
      duration: 0.12,
      ease: "power1.out"
    })

    // Hold on punchline
    tl.to({}, { duration: 0.15 })
  }
}
